export const iIcon = () => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_233_2780)'>
        <path
          d='M7.99935 1.33341C4.31745 1.33341 1.33268 4.31818 1.33268 8.00008C1.33268 11.682 4.31745 14.6667 7.99935 14.6667C11.6812 14.6667 14.666 11.682 14.666 8.00008C14.666 4.31818 11.6812 1.33341 7.99935 1.33341Z'
          stroke='#ADADAD'
          stroke-width='1.63447'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path d='M8 10.6667L8 8.00008' stroke='#ADADAD' stroke-width='1.63447' stroke-linecap='round' stroke-linejoin='round' />
        <path d='M8 5.33325L7.993 5.33325' stroke='#ADADAD' stroke-width='1.63447' stroke-linecap='round' stroke-linejoin='round' />
      </g>
      <defs>
        <clipPath id='clip0_233_2780'>
          <rect width='16' height='16' fill='white' transform='translate(16 16) rotate(180)' />
        </clipPath>
      </defs>
    </svg>
  );
};
